import React from 'react'
import './Style.css'
import Logo from '../assets/Logo.png';


export default function Footer() {
    return (
        <>
           <div className="page-footer">
             <footer className="footer">
              <div className="container py-3">
                        <div className="row">
                         <div className="col-8 items-center ">
                        <img src={Logo} width="40px" heigth="40px"/>
                        <span className="text-small text-muted"> @ Token Maker</span>
                            </div><div className="col-12 col-md-4">
                                <button type="button" className="btn footer-link py-0">Terms of use</button>
                                <a className="btn footer-link py-0" href="/#faq">Help</a>
                                <a className="btn footer-link py-0" target="_blank" rel="noopenner noreferrer" href="#">Tokenmaker</a>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    )
}
